import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const preview = faqs.slice(0, 4);
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[360px_1fr] lg:items-start">
          <div className="lg:sticky lg:top-24">
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容来源、核实方式与反馈渠道，这里集中回答了几个最常被问到的问题。
            </p>
            <Link
              to="/faq"
              className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
            >
              查看全部问题
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
          <FaqAccordion items={preview} />
        </div>
      </div>
    </section>
  );
}